import {
    alpha,
    DialogContent,
    IconButton,
    IconButtonProps,
    Paper,
    Stack,
    styled,
    TypographyProps,
} from "@mui/material";
import { HeadingS, Icons } from "..";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { InternalButtonLink } from "../InternalButtonLink";
import { toPx } from "../MuiHelpers";

export const ModalPaper = styled(
    Paper,
    styledOmitPropsOptions,
)<{ $width: number | string }>(({ theme, $width }) =>
    theme.unstable_sx({
        py: theme.spacing(0),
        px: theme.spacing(0),
        width: toPx($width),
        borderRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        maxHeight: "90vh",
        display: "flex",
        flexDirection: "column",
    }),
);

export const ModalDialogTitleStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        py: theme.spacing(4),
        px: theme.spacing(4),
        position: "relative",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    }),
);

export const ModalDialogTitleText = styled((props: TypographyProps) => <HeadingS {...props} />)(({ theme }) =>
    theme.unstable_sx({
        width: "85%",
        mb: 0,
        alignSelf: "center",
        textAlign: "center",
        fontWeight: theme.typography.fontWeightMedium,
    }),
);

export const ModalDialogContent = styled(DialogContent)(({ theme }) =>
    theme.unstable_sx({
        py: theme.spacing(5),
        px: theme.spacing(4),
        boxShadow: `inset 0 -4px 8px 0 ${alpha(theme.palette.common.black, 0.1)}`,
        borderTop: `1px solid ${theme.palette.divider}`,
    }),
);

export const ModalButton = styled(InternalButtonLink)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        m: theme.spacing(3),
    }),
);

export const ModalCloseButton = styled((props: IconButtonProps) => {
    return (
        <IconButton {...props}>
            <Icons.Close />
        </IconButton>
    );
})(({ theme }) =>
    theme.unstable_sx({
        position: "absolute",
        right: theme.spacing(4),
        minWidth: "18px",
        height: "max-content",
        minHeight: "18px",
        color: theme.palette.primary.main,
    }),
);
